export default __webpack_public_path__ + "static/media/blogDetail1.7ceae708.png";